<template>
	<el-scrollbar wrapClass="scrollbar-wrapper" class="scroll-wrapper">
		<el-menu mode="vertical" :show-timeout="200" :default-active="$route.path" :collapse="isCollapse" background-color="#EEEFF2" text-color="#666" active-text-color="#f10d3b" active-background-color="#DCDFE6">
			<sidebar-item :routes="navList" :isFrame.sync="isFrame" :expanded="expandedState"></sidebar-item>
		</el-menu>
	</el-scrollbar>
</template>
<script>
import { mapGetters } from "vuex"
import SidebarItem from "./SidebarItem"
import * as services from './services.js'
import { error } from 'util'
import menuList from './menu.js'
export default {
  props: {
    isFrame: {
      type: Object,
      default: () => {
        return {
          isUse: false
        }
      }
    }
  },
  data() {
    return {
      navActiveIndex: 0,
      navList: [],
      expandedState:{},
      menu: {}
    }
  },
  mounted() {
    this.getNavList()
    
  },
  methods: {
    getNavList() {
      services.getMenus({}, { errorMsg: 'none' }).subscribe(data => {
        if(!!data.data){
           data.data.forEach((i,v) => {
            if(i.chirdMenuList&&i.chirdMenuList.length) {
              i.chirdMenuList.forEach((j,k) => {
                if(j.url.indexOf('popWeb') > -1) {
                  j.open = true
                }
              })
            }
           })
           this.navList = data.data
           this.addViewTags()
           this.initializeExpandedState(this.navList);
        }
      })
    },
    initializeExpandedState(menuItems) {
      menuItems.forEach(item => {
        this.$set(this.expandedState, item.id, true);
        if (item.chirdMenuList && item.chirdMenuList.length > 0) {
          this.initializeExpandedState(item.chirdMenuList); // 递归设置二级菜单为展开
        } 
      });
    },
    addViewTags(){
      let  { name, path } = this.$route
      if (name) {
        let view= this.$route
         this.$store.dispatch('addViews', { //这要是直接传整个view过去会报栈溢出，不传matched属性过去就没事。
            path:view.path,
            query:view.query,
            name:view.name,
            fullPath:view.fullPath,
            meta:view.meta,
            params:view.params,
            hash:view.search,
        }, this.menu)
    }
      return false
    },
  },
  components: {
    SidebarItem
  },
  watch:{
    $route(newVal, oldVal){
      sessionStorage.removeItem('perUrl')
      this.addViewTags()
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style lang="less" scoped>
  .scroll-wrapper /deep/ .scrollbar-wrapper {
      overflow-x: hidden
    }
</style>


